import {
  CallHighlightFragment,
  CandidateHighlightFragment,
  CandidateInterviewFragment,
} from "../../graphql";

export enum InterviewMenuOptions {
  SHARE = "share",
  DELETE = "delete",
  COPY_AI_NOTES = "copy_ai_notes",
  VIEW = "view",
}

export type CandidateCall = CandidateInterviewFragment &
  CandidateHighlightFragment;

export type CallHighlight = CallHighlightFragment & {
  call: CandidateCall;
};
